import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
export default function getUniqueFieldNames(objects) {
  var fields = new Set();
  objects.forEach(function (o) {
    Object.keys(o).forEach(function (field) {
      fields.add(field);
    });
  });
  return fields;
}